import { FC, useState } from 'react';

interface GroupParticipantsPanelIconProps {
  width?: number;
  height?: number;
  className?: string;
  /** Показывать красный бейдж (есть ожидающие подключение). По умолчанию true. */
  showBadge?: boolean;
  /** Панель участников открыта — выделить иконку (как у демонстрации экрана). */
  checked?: boolean;
}

/** Иконка «Участники группы»: без бейджа — когда нет ожидающих, с красным кругом — когда есть. */
export const GroupParticipantsPanelIcon: FC<GroupParticipantsPanelIconProps> = ({
  width = 48,
  height = 48,
  className = '',
  showBadge = true,
  checked = false,
}) => {
  const [hover, setHover] = useState(false);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ display: 'block', verticalAlign: 'top', margin: 0 }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <title>Участники встречи</title>
      <rect width="48" height="48" rx="10" fill={checked ? '#2C3038' : hover ? '#6F6F6F' : '#828282'} />
      <path
        fill="white"
        d="M28.6 24.24C30.49 24.24 32.12 22.55 32.12 20.34C32.12 18.17 30.48 16.56 28.6 16.56C26.71 16.56 25.07 18.2 25.07 20.36C25.07 22.55 26.7 24.24 28.6 24.24ZM18.46 24.44C20.1 24.44 21.53 22.96 21.53 21.05C21.53 19.16 20.09 17.76 18.46 17.76C16.82 17.76 15.38 19.19 15.39 21.07C15.39 22.96 16.82 24.44 18.46 24.44M13.55 32.39H20.24C19.33 31.06 20.44 28.38 22.34 26.92C21.36 26.27 20.1 25.79 18.45 25.79C14.48 25.78 12 28.72 12 31.16C12 31.95 12.44 32.39 13.55 32.39ZM23.06 32.39H34.12C35.51 32.39 36 31.99 36 31.22C36 28.95 33.16 25.81 28.59 25.81C24.03 25.81 21.18 28.95 21.18 31.22C21.18 31.99 21.68 32.39 23.06 32.39Z"
      />
      {showBadge && <circle cx="39" cy="9" r="5" fill="#C00000" />}
    </svg>
  );
};
